export default "__VITE_ASSET__C$du1ALY__"